export default __webpack_public_path__ + "static/media/2.acc39e17.jpg";